<template>
  <v-card outlined>
    <v-simple-table dense fixed-header height="600px">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left" style="min-width: 130px">Código</th>
            <th class="text-left" style="min-width: 400px">Nombre de Cuenta</th>
            <th class="text-right">P. Inicial</th>
            <th v-for="m in meses" :key="m" class="text-right">{{ m }}</th>
            <th class="text-right">Total</th>
            <th class="text-right">Saldo</th>
          </tr>
        </thead>

        <tbody>
          <tr v-if="!items.length">
            <td colspan="17" class="text-center">
              <div v-if="cargando" class="pa-8">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                <p class="mt-2">Cargando datos...</p>
              </div>

              <div v-else class="pa-8">
                <v-icon size="64" color="grey lighten-2">mdi-table-off</v-icon>

                <p class="mt-2">No se encontraron datos para mostrar</p>
              </div>
            </td>
          </tr>

          <FilaPartidaAgrupada
            v-for="item in items"
            :key="item.id"
            :item="item"
            :level="0"
            :meses-keys="mesesKeys"
            :force-expand="expandAll" />
        </tbody>

        <tfoot v-if="items.length">
          <tr class="font-weight-bold grey lighten-3">
            <td colspan="2" class="text-right">TOTALES</td>
            <td class="text-right">{{ format(totales.presupuesto_inicial) }}</td>
            <td v-for="m in mesesKeys" :key="m" class="text-right">
              {{ format(totales[m]) }}
            </td>
            <td class="text-right blue--text">{{ format(totales.total) }}</td>
            <td class="text-right font-weight-black">{{ format(totales.saldo_presupuestario) }}</td>
          </tr>
        </tfoot>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import FilaPartidaAgrupada from '../components/FilaPartidaAgrupada.vue';

export default {
  name: 'ListadoReporteEjecucionPresupuestariaAgrupado',
  components: { FilaPartidaAgrupada },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    cargando: {
      type: Boolean,
      default: false,
    },
    expandAll: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    meses: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    mesesKeys: [
      'enero',
      'febrero',
      'marzo',
      'abril',
      'mayo',
      'junio',
      'julio',
      'agosto',
      'septiembre',
      'octubre',
      'noviembre',
      'diciembre',
    ],
  }),
  computed: {
    totales() {
      const campos = ['presupuesto_inicial', ...this.mesesKeys, 'total', 'saldo_presupuestario'];
      const sumas = {};

      campos.forEach((campo) => {
        sumas[campo] = this.items.reduce((acc, item) => acc + (item[campo] || 0), 0);
      });

      return sumas;
    },
  },
  methods: {
    format(val) {
      return new Intl.NumberFormat('es-BO', { minimumFractionDigits: 2 }).format(val || 0);
    },
  },
};
</script>